import UserService from "./services/UserService";

const Menu = (name, path, icon, isPrivate = true, children = [],
  roles = []) => {
  return {name, path, icon, isPrivate, children, roles};
};

export const AllMenus = [
  Menu('Home', '/', 'fa-home'),

  Menu('Alertas', null, 'fa-bell', true, [
    Menu('Configuração de disparo ', '/list/alerts-triggers', 'fa-cog'),
    Menu('Lista de alertas ', '/list/alerts', 'fa-list'),
    Menu('Grupo de alertas', '/list/notifications-groups', 'fa-users'),
    Menu('Gráfico de alertas', '/alerts-chart', 'fa-bar-chart')
  ]),

  Menu('Configuração', null, 'fa-cogs', true, [
    Menu('Empresas', '/list/companies', 'fa-industry', true, [],
      [UserService.ROLE_SUPER]),
    Menu('Pontos de Controle', '/list/checkpoints', 'fa-podcast', true, [],
      [UserService.ROLE_ADMIN]),
    Menu('Pontos de Leitura', '/list/readpoints', 'fa-dot-circle-o', true, [],
      [UserService.ROLE_ADMIN]),
    Menu('Configurações da empresa', '/list/company-configurations', 'fa fa-wrench', true, []
      [UserService.ROLE_ADMIN]),
  ], [UserService.ROLE_ADMIN]),

  Menu('Cadastros', null, 'fa-edit', true, [
    Menu('Locais', '/list/biz-locations', 'fa-map-o', true, [],
      [UserService.ROLE_ADMIN]),
    Menu('Usuários', '/list/users', 'fa-users', true, [],
      [UserService.ROLE_ADMIN]),
    Menu('Usuários  de Integração', '/list/integration-users', 'fa-users', true,
      [], [UserService.ROLE_SUPER]),
    Menu('Tipos de Produto', '/list/product-types', 'fa-cube'),
    // Menu('Mobile', '/list/devices', 'fa-mobile-phone', true, [], [UserService.ROLE_ADMIN]),
    Menu('Maps', '/list/maps', 'fa-map', true, [], [UserService.ROLE_SUPER]),
    Menu('Ordem de Movimentação', '/list/movement-orders', 'fa-share'),
    Menu('Disposição', '/list/dispositions', 'fa-edit'),
    Menu('Etapa', '/list/biz-steps', 'fa-truck')
  ]),

  Menu('Dashboard', null, 'fa fa-tachometer', true, [
      Menu('Configuração de Dashboard', '/list/dashboard-templates', 'fa fa-wrench', true, [], [UserService.ROLE_DASH_CONFIG]),
      Menu('Mapa de Vagas', '/dash/assets/polygon', 'fa fa-wrench', true, [], [UserService.ROLE_MAP_VACANCY]),
      Menu('Aplicativos', '/dash/mobile-applications', 'fa fa-mobile', true, [], [UserService.ROLE_SUPER]),
    ],
    [UserService.ROLE_DASH_CONFIG, UserService.ROLE_MAP_VACANCY, UserService.ROLE_SUPER]),

  Menu('Estoque', null, 'fa-clone', true, [
    Menu('Estoque', '/list/all-assets', 'fa-line-chart'),
    Menu('Saldo atual', '/list/balance', 'fa-line-chart'),
    Menu('Níveis de estoque', '/list/stock-levels', 'fa-bar-chart'),
    Menu('Evolução do parque', '/stock-levels/evolution', 'fa-area-chart'),
    Menu('Status Geral', '/stock-levels/dashboard', 'fa-pie-chart'),
    Menu('Inventário', '/list/inventories', 'fa-archive'),
    Menu('Últimas Movimentações', '/latest-movements', 'fa-refresh'),
    // Menu('BizTransaction', '/list/biz-transactions', 'fa-share'),
  ]),

  Menu('Comissionador', '/commissioner', 'fa-tags', true, [],
    [UserService.ROLE_USER]),

  Menu('Hardware', null, 'fa-cubes', true, [
      Menu('Gateways', '/list/gateways', 'fa-hdd-o'),
      Menu('Nodes', '/list/nodes', 'fa-sitemap'),
      Menu('Sensings', '/list/sensing', 'fa-map-pin'),
    ],
    [UserService.ROLE_ADMIN]),

  Menu('Ferramentas de implementação', null, 'fa-code-fork', true, [
      Menu('Tag de mapas', '/epc-distance/new', 'fa-map-signs'),
      Menu('Teste de Posição', '/current-position', 'fa-map-pin'),
    ],
    [UserService.ROLE_SUPER]),

  Menu('Rastreabilidade', null, 'fa-map-marker', true, [
      // Menu('Timeline', '/track', 'fa-search-plus'),
      Menu('Transações', '/list/transactions', 'fa-exchange'),
      Menu('Movimentações', '/list/movement-by-product-type', 'fa-exchange'),
      Menu('Produtos movimentados', '/list/moved-products', 'fa-exchange'),
      Menu('Itens das transações', '/list/transactions-items', 'fa-cube'),
      // Menu('Beacons Events', '/bluzone', 'fa-cog')
    ],
    [UserService.ROLE_USER]
  ),

  Menu('Integração', null, 'fa-plug', true,
    [
      Menu('Mensagens', '/list/integration-messages', 'fa-commenting'),
      // Menu('Eventos Beacons', '/list/policy-events', 'fa-cog'),
      Menu('Configurações', '/list/integration-configurations', 'fa-cog'),
    ], [UserService.ROLE_SUPER]),

  Menu('Portais', '/portals', 'fa-cog')
  // Menu('Alertas', '/sensings', ' fa-bullhorn')
];



// WEBPACK FOOTER //
// ./src/Menus.js